export const DyLangEs = {
    dashbordDy: { 
    nochoosed:"No sealecciondo",open:'abierto' ,isOpen:'Si va a abrir el caso?',
    smsStats:'sms stats',
    totalsendnum:'Total amount sent',
    selfsendnum:'Myself send',
    contactsendnum:'Contacts sent',
    notickets:'No tiene boletos pendientes, recuerde al gerente que divida los boletos',
    originalOrderNumber:'Número de orden original',
    Repayment:'Reembolso',
    RelatedInformation:'Información relacionada',
    yes:"si",
    no:'no',
    auditFailed:'Auditoría fallida',
    examinationPassed:"examen aprobado",
    Unreviewed:'No revisado',
    NextCallTime:'Hora de la próxima llamada',
    unassign:'¿Estás seguro de anular la asignación?',
    assigntime:'Tiempo de asignación de órdenes de trabajo',
    startime:'Hora de inicio de la orden de trabajo',
    completetime:'Hora de finalización de la orden de trabajo',
    normal:'normal',
    AbusiveCustomer:'Cliente abusivo',
    sop:'No se encuentra con el bocado',
    CustomerPromises:"El compromiso y el recordatorio del cliente son inconsistentes",
    CollectionInformation:'Información de la colección',
    QualityInspectionInformation:'Información de inspección de calidad',
    Aging:'Envejecimiento',
    DialTime:'Tiempo de marcado',
    HangUpReason:'Cuelga la razón',
    recording:'grabación',
    RecordingType:'Tipo de grabación',
    processResult:'resultado del proceso',
    queryConditions:'Por favor, complete al menos una información de consulta',
    characters:'La etiqueta no puede superar los 80 caracteres.',
    ticketID:'ID de orden de trabajo de inspección de calidad',
    RepaymentCode:'Código de reembolso',
    RepaymentCodeChannel:'Canal de código de reembolso',
    selectRepaymentCodeChannel:'Primero seleccione el canal del código de reembolso',
    AppName:'Nombre del Producto',
    selectAppName:'Por favor seleccione el proyecto',
    subItem: 'Ya sea para dividir el proyecto',
    Totalorders:'Cartera total',
    Pleaseentervaliddays:'Ingrese días válidos',
    Date:'Fecha',
    HandleNumber:'Total de gestiones ',
    HandleNumberpercent:'Total de porcentaje de gestiones ',
    TotalUnconnected:"Total de no contactados",
    Busy:"Busy",
    Reject:	"Reject",
    CaseLevel:'Clasificación de cartera',
    NotActive:	"Not Active",
    CustomerBlocked	:"Customer Blocked"	,
    ContinueRinging:"Continue Ringing",
    TotalConnected:	"Total de contactados",
    NoMoney:	"No Money"	,
    LeftMessagetoCP:'Left Message to CP',
    WTP:'Willing to Pay',
    PartialPayment:	'Partial Payment',
    Rolling	:'Rolling',
    BP:	"Broken Promise",
    Underestimate:	'Underestimate',
    DelayPayment:'Delay Payment'	,
    DataInvalid:'Data Invalid'	,
    NotCustomer:'Not Customer',
    DidReceiveMoney:'Customer Didnt Receive Money',
    Unconnected	:'No contactado',
    Connected:'Contactado',
    ConfirmApplyForInterestFreeze: "Are you sure you want to apply for an interest freeze?",
    StatusOfApplyForInterestFreeze: "Apply for interest freeze status: ",
    unknownFreezeStatus: "Desconocido",
    numbersofperpage: 'Número de artículos por página',
    oldnewtickets: 'Órdenes de nuevas y antiguas',
    newtickets: 'Nueva orden',
    oldtickets: 'Antigua orden',
    canApplyForInterestFreeze: 'interest freeze can be applied for',
    interestFreezeing: 'interest Freezing',
    cannotApplyForInterestFreeze: 'interest freeze can not be applied for',
    GetQRcode:'Obtener el código QR',
    QRcodebelow:'Por favor, inicie sesión en WhatsApp en su teléfono móvil y escanee el siguiente código QR para iniciar sesión en WhatsApp',
    WhatsAppaccount:'Por favor, introduzca la información de su teléfono móvil para iniciar sesión en WhatsApp:',
    manual: 'Manualmente',
    automatic: 'Automáticamente',
    UnmarkedContent:"Contenido sin marcar",
        recordingDuration:"duración de la grabación",
        MachineQuality:"estado de inspección de calidad por maquina",
        QualityEnspection:"estado de inspección de calidad",
        CollectionVoice:'Audio de cobranza',
        salesman:"asesor",
        user:"Usuario",
        Collector:'coleccionista',
        QualityInspector:"Inspector de calidad",
        QualityInspectionRecording:'Registro de gestión de órdenes de trabajo de inspección de calidad',

             FinalQualityinspectionscore:"puntuación final del calidad",
             AIQualityInspectionScore:"puntuación de calidad via AI",
             ManualQualityInspectionScore: "puntuación de calidad via manual",
            triggerFragment:"Frase violada",
           triggerRule:"Regla Violada ",
            ruleId:"ID de regla",
             QualityInspectionType:"tipo de calidad",
          keywordsPhrases:"vocabulario / frase ",
           Score:"calificación",
           AIQualityInspectionConfiguration:"Configuración de calidad AI",
           keywordLibrary:'palabras claves',
           QualityInspectionRules:'reglas de calidad',
           QCtext:'texto de calidad',
           QualityInspectionTemplate:"plantilla de calidad",
           newTalkPoint:"crear nuevo vocabulario",
        founder:'Operador',
              TalkPointName:"Nombre de categoría de vocabulario  ",
                Talkingpointlibrary:'categoria de vocabulario',
                NumberOfSpeakingPoints:"cantidad de vocabularios",
                RuleID:"ID de regla",
                 ruleName:"nombre de la regla",   
        AddPoints:'Puntos extra',
        MinusPoints:'Puntos menos',
       Scoring:'modo de puntuación',
       score:'puntuación',
       TheNumberOfQualityInspectionPoints:'Número de puntos de inspección de calidad.',
       BasicInformation:"Información basica",
       RulesDescription:"Descripción de las reglas",
       numberofmatches:"numero de coincidencias",
       QualityInspectionPoints:"punto de inspección de calidad",
       QCPointType:"categoría de punto de inspección d calidad",
       QCobject:'objeto de calidad',
       SpellPointHitRules:"vocabulario que viola la regla",
       Within:"seguidos",
        consecutiveReplies:"dentro de # veces",
        Repeat :'Coincidencia duplicada',
        times:'numero de veces',
        AddQCpoint:"Agregar punto de inspección de calidad", 
        Thelogical:" La relación lógica entre los puntos de inspección de calidad",
        or:"O",
        and:'Y',
                 templateName:'Nombre de la plantilla ',
                  enabledstate:'Estado Activo',
                  Scopeofapplication:'Ámbito de aplicación',
                 Containstherulebook:'Contiene el número de reglas. ',
                  Inclusionrules:'Contiene regla',
                 currentstate:'Estado Actual ',
                  Disable:'desactivado',
                         addNewRules:'Crear nueva regla',
                          TemplateDescription:'Descripción de plantilla',
                         Applicableaccountperiod:'Bucket  que se aplica',
                         Qualityinspectionscoringitems:'Elemento de Puntaje de inspección de calidad',
                         Addaratingitem:'Agregar elemento de puntuación',
                         artificial:'Manual',
                         abandoned:'Abandonar',
                         Obsolete:'Abandonado',
                         Copywriting:'Corrección de texto',
                         Qualityinspectionlabel:'Marca de inspección de calidad',
                         correctcopywriting:'Texto correcto',
        speechrecognitioncopywriting:'Reconocimiento de voz',
         voiceclip:'fragmento de audio',
         return:"Regresar",
         fix:"Corregir",
         Nocorrectionrequired:"No se requiere corrección",
         AIqualityinspectionstatus:"estado de inspección de calidad vía AI",
         Manualqualityinspectionscore:"puntuación de calidad via manual",
         AIqualityinspectionscore:"puntuación de calidad via AI ",
         WaktupemeriksaankualitasAI:"Tiempo de inspección de calidad vía AI",
         Notinspected:'sin inspeccionar',
         Qualityinspected:"Inspeccionado",
         created:"creado",
         unlimited:'sin limite',
        activated:"En uso",
        terminated:'Terminado',
        finalscore:"puntuación final",
        scoreisrepeated:'Elemento de puntuación de inspección de calidad repetido, favor de verificar y vuelva a enviar',
        previouspage:'El contenido de tu edición todavía no ha sido subido. Estás seguro que abandonas la edición y regresas a la página anterior?',
        continueediting:'Continuar editando',
        confirmreturn:'Confirmar a regresar',
        SpeechRecognitionCopywritinga:'correción de redacción',
        UpdateAIscore:"Actualizar puntuación de IA",
        resultsafterwhile:'Actualizar puntuación de IA',
        Enterkeywordstofilter:'Introduzca palabra clave para filtrar',

        IntentAnnotation:"anotación de intención",
        modifyIntent:"modificar intención",
        
    HandlingAdvice:'Consejos de manipulación',			
    callLabel:'etiqueta de llamada'	,
    	
Isitarobot:"es un robot	",		
        Robotlabel:"Etiqueta de robot",		
        nolabel:'sin etiqueta'	,					
        repaymenttime:'Tiempo de pago',
        UserIntent:'Intención del usuario (opción única)',
        RepaymentWay:'Método de pago',
        RepaymentAmount:"Monto de pago",
        inputMessage: 'ingresar mensaje',
        Promisedrepaymentamount:'Cantidad de reembolso comprometida',
        Dialogueerrorcorrection:"Corrección de errores de diálogo",
        Modifyerrorcorrection:"Modificar corrección de errores",
        notWAUser: 'La persona no es usuario de WhatsApp',
        notLoginWA: 'La cuenta actual no está logueada en WhatsApp',
        alreadyLoginWA: 'Estás conectado a WhatsApp',
        pleaseSelectChat: 'Por favor seleccione un chat',
        emptyMessage: 'El mensaje de chat no puede estar vacío',
        noTemplateMessage: 'Los mensajes personalizados no son compatibles',

        hitstatement:"declaración de éxito",
        Identifycause:"Identificar la causa del error",
}
};

